import { Component, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import _ from 'lodash';
import { OrderV2Service } from '@root/router/order-v2/order-v2.service';

@Component({
  selector: 'host-fail-houses',
  templateUrl: './fail-houses.component.html',
  styleUrls: ['./fail-houses.component.scss']
})
export class FailHousesComponent implements OnInit {

  houseLists = [];
  total = 0;
  constructor(
    private subject: NzModalRef,
    private orderService: OrderV2Service,
  ) { }

  ngOnInit() {
    this.getDetail();
  }

  getDetail() {
    this.orderService.getAirbnbFailedList().subscribe(res => {
      if (res.error_code === 0) {
        this.houseLists = res.data.list;
        this.total = this.houseLists.length;
      }
    });
  }

  chooseHouse(house) {
    this.subject.destroy({
      house: house,
      title: 'openAuditDetail',
    });
  }

}
